import { testResultsActionTypes } from './Constants';

export function getAnswers(testResultsId) {
	return {
		type: testResultsActionTypes.GET_ANSWERS,
		payload: {
			testResultsId,
		},
	};
}

export function getAnswersSuccess(answers) {
	return {
		type: testResultsActionTypes.GET_ANSWERS_SUCCESS,
		payload: {
			answers,
		},
	};
}

export function getResultsDetails(testResultsId, eventSource) {
	return {
		type: testResultsActionTypes.GET_RESULTS_DETAILS,
		payload: {
			testResultsId,
			eventSource,
		},
	};
}

export function getResultsDetailsSuccess(resultsDetails) {
	return {
		type: testResultsActionTypes.GET_RESULTS_DETAILS_SUCCESS,
		payload: {
			resultsDetails,
		},
	};
}

export function getResults(testResultsId, query) {
	return {
		type: testResultsActionTypes.GET_RESULTS,
		payload: {
			testResultsId,
			query,
		},
	};
}

export function getResultsSuccess(results) {
	return {
		type: testResultsActionTypes.GET_RESULTS_SUCCESS,
		payload: {
			results,
		},
	};
}

export function getResultsError() {
	return {
		type: testResultsActionTypes.GET_RESULTS_ERROR,
	};
}

export function getTopicAnswers(exerciseId, topicId, query) {
	return {
		type: testResultsActionTypes.GET_TOPIC_ANSWERS,
		payload: {
			exerciseId,
			topicId,
			query,
		},
	};
}

export function getTopicAnswersSuccess(topicId, topicAnswers) {
	return {
		type: testResultsActionTypes.GET_TOPIC_ANSWERS_SUCCESS,
		payload: {
			topicId,
			topicAnswers,
		},
	};
}

export function getTopicAnswersError(topicId, error) {
	return {
		type: testResultsActionTypes.GET_TOPIC_ANSWERS_ERROR,
		payload: {
			topicId,
			error,
		},
	};
}

export function clearTestResults() {
	return {
		type: testResultsActionTypes.CLEAR_TEST_RESULTS,
		payload: {},
	};
}
